import React from "react";
import { Avatar, Box, Skeleton } from "@mui/material";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";

interface ThumbnailFotoProps {
  url?: string;
  alt?: string;
  size?: number;
  loading?: boolean;
  onDoubleClickPlaceholder?: () => void;
}

const ThumbnailFoto: React.FC<ThumbnailFotoProps> = ({
  url,
  alt = "Foto",
  size = 50,
  loading = false,
  onDoubleClickPlaceholder,
}) => {
  if (loading) {
    return <Skeleton variant="rectangular" width={size} height={size} />;
  }

  if (!url) {
    return (
      <Box
        onDoubleClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          if (onDoubleClickPlaceholder) {
            onDoubleClickPlaceholder();
          }
        }}
        sx={{
          width: size,
          height: size,
          bgcolor: "grey.50",
          borderRadius: 1,
          border: "1px solid",
          borderColor: "grey.300",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: onDoubleClickPlaceholder ? "pointer" : "default",
          "&:hover": onDoubleClickPlaceholder ? {
            bgcolor: "grey.100",
          } : {},
        }}
      >
        <AddPhotoAlternateIcon sx={{ color: "grey.400", fontSize: size * 0.5 }} />
      </Box>
    );
  }

  return (
    <Box
      onDoubleClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        if (onDoubleClickPlaceholder) {
          onDoubleClickPlaceholder();
        }
      }}
      sx={{
        width: size,
        height: size,
        bgcolor: "grey.100",
        borderRadius: 1,
        border: "1px solid",
        borderColor: "grey.300",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        cursor: onDoubleClickPlaceholder ? "pointer" : "default",
      }}
    >
      <Box
        component="img"
        src={url}
        alt={alt}
        sx={{
          maxWidth: "100%",
          maxHeight: "100%",
          width: "auto",
          height: "auto",
          objectFit: "contain",
        }}
      />
    </Box>
  );
};

export default ThumbnailFoto;
